import { Skeleton } from '@/components/ui/skeleton';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { formatTime } from '@/lib/format';

interface SessionOption {
  id: string;
  startTime: string;
  endTime: string;
  sessionType: string | null;
  courtLocation: string | null;
}

interface MakeupFormModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  sessionDate: string;
  onSessionDateChange: (date: string) => void;
  sessions: { sessions: SessionOption[] } | null | undefined;
  onSelectSession: (sessionId: string) => void;
  isPending: boolean;
}

export function MakeupFormModal({
  open,
  onOpenChange,
  sessionDate,
  onSessionDateChange,
  sessions,
  onSelectSession,
  isPending,
}: MakeupFormModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Schedule Makeup Session</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-foreground">Select date</label>
            <input
              type="date"
              value={sessionDate}
              onChange={(e) => onSessionDateChange(e.target.value)}
              className="mt-1 w-full rounded-md border border-input bg-background text-foreground px-3 py-2 text-sm"
            />
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">Available sessions</label>
            {sessions == null ? (
              <Skeleton className="h-16 w-full" />
            ) : sessions.sessions.length === 0 ? (
              <p className="text-sm text-muted-foreground py-4 text-center">
                No sessions on this date
              </p>
            ) : (
              sessions.sessions.map((session) => (
                <button
                  key={session.id}
                  onClick={() => onSelectSession(session.id)}
                  disabled={isPending}
                  className="w-full text-left p-3 border border-border rounded-lg hover:bg-muted/50 transition"
                >
                  <p className="font-medium text-foreground">
                    {formatTime(session.startTime)} - {formatTime(session.endTime)}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {session.sessionType || 'Training'}
                    {session.courtLocation && ` • ${session.courtLocation}`}
                  </p>
                </button>
              ))
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
